var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[_c('v-col',{staticClass:"py-0 my-0 pb-3",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"mt-0",attrs:{"value":_vm.value,"label":_vm.label,"hide-details":""},on:{"change":_setup.updateValue}})],1),(_vm.value)?[_c('v-row',{staticClass:"ml-8 pb-4"},[_vm._t("default")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }